import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AgentAuthContext = createContext();

export const useAgentAuth = () => {
  const context = useContext(AgentAuthContext);
  if (!context) {
    throw new Error('useAgentAuth must be used within AgentAuthProvider');
  }
  return context;
};

export const AgentAuthProvider = ({ children }) => {
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  const API = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    const token = localStorage.getItem('agentToken');
    if (token) {
      fetchAgentProfile(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchAgentProfile = async (token) => {
    try {
      const response = await axios.get(`${API}/api/agent/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setAgent(response.data.agent);
    } catch (error) {
      console.error('Failed to fetch agent profile:', error);
      localStorage.removeItem('agentToken');
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/api/agent/auth/login`, {
        email,
        password
      });

      const { token, agent } = response.data;
      localStorage.setItem('agentToken', token);
      setAgent(agent);
      
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Login failed'
      };
    }
  };

  const register = async (data) => {
    try {
      const response = await axios.post(`${API}/api/agent/auth/register`, data);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Registration failed'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('agentToken');
    setAgent(null);
  };

  const value = {
    agent,
    loading,
    login,
    register,
    logout
  };

  return (
    <AgentAuthContext.Provider value={value}>
      {children}
    </AgentAuthContext.Provider>
  );
};
